export default typeof console === 'undefined'
  ? {
      log: () => null,
      debug: () => null,
      info: () => null,
      warn: () => null,
      error: () => null,
    }
  : console
